module.exports = __webpack_public_path__ + "static/media/intellij.d3d3049e.png";